import type { V1InfoPaymentTryoutCoupon } from '@zelos/codegen/apis';
import { useMemo } from 'react';

type CalcPriceProps = {
  fee?: string | number | null,
  coupon?: V1InfoPaymentTryoutCoupon | null,
  employeeFee?: string | number | false | null,
};

export const useCalcPrice = ({
  fee,
  coupon,
  employeeFee,
}: CalcPriceProps) => {
  const discountByEmployeeFee = useMemo(() => {
    if (!fee || !employeeFee) return 0;

    const feeNumber = Number(fee);
    const employeeFeeNumber = Number(employeeFee);
    if (employeeFeeNumber > feeNumber) return 0;
    return Math.trunc(feeNumber - employeeFeeNumber);
  }, [employeeFee, fee]);

  const discountByCoupon = useMemo(() => {
    if (!fee || !coupon) return 0;

    const {
      discountAmount: discountAmountRaw,
      discountRate,
    } = coupon;

    const discountAmount = Number(discountAmountRaw);

    if (discountRate) return Math.trunc((Number(fee) - discountByEmployeeFee) * discountRate / 100);
    if (discountAmount > 0) return Math.trunc(discountAmount);

    return 0;
  }, [discountByEmployeeFee, fee, coupon]);

  const price = useMemo(() => {
    if (!fee) return 0;
    return Math.trunc(Number(fee) - discountByEmployeeFee - discountByCoupon);
  }, [discountByCoupon, discountByEmployeeFee, fee]);

  return {
    discountByEmployeeFee,
    discountByCoupon,
    price,
  };
};
